// Libraries
import {Col, Dropdown, MenuProps} from 'antd';
import {
  DownloadOutlined, DownOutlined,
  PlusOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

// Components
import ButtonComponent from "../subComponents/ButtonComponent";

// Store
import { useAppDispatch } from '../../store/store';
import { getCategoriesTemplate } from '../../store/redux/actions/categoryActions';


type CategoriesTopButtonsType = {
  isSmallScreen: Boolean,
  onToggleUploadCategoryModal: () => void;
  onToggleCategoryModal: () => void;
};
const CategoriesTopButtons = (props: CategoriesTopButtonsType) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const dropdownItems: MenuProps['items'] = [
    {
      key: '1',
      label: <span className={'text-blue-dkt-400'}
                   onClick={() => dispatch(getCategoriesTemplate())}>
        {t('downloadTemplate')}
      </span>,
      icon: <DownloadOutlined className={'text-blue-dkt-400'} />,
    },
    {
      key: '2',
      label: <span className={'text-orange-dkt-400'}
                   onClick={props.onToggleUploadCategoryModal}>
        {t('loadCategories')}
      </span>,
      icon: <UploadOutlined className={'text-orange-dkt-400'} />,
    }
  ];

  return (
    <Col md={24} xs={24} className={'sm:text-right mt-4 sm:mt-0'}>
      <ButtonComponent text={t('newCategory')}
                       icon={<PlusOutlined />}
                       className={'m-0.5 bg-blue-dkt-400 text-white hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                         'focus:ring-offset-2 focus:ring-blue-dkt-300 '}
                       onClick={props.onToggleCategoryModal}/>
      <Dropdown menu={{ items: dropdownItems }}
                arrow={true}
                trigger={['click']}>
        <ButtonComponent text={t('actions')}
                         icon={<DownOutlined />}
                         className={'text-blue-dkt-400 bg-white hover:bg-blue-dkt-100 border-blue-dkt-400 ' +
                           'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dkt-300 '} />
      </Dropdown>
    </Col>
  );
}

export default CategoriesTopButtons;